import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import '../styles/View.css';

const View = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [quantity, setQuantity] = useState(1);
  const [activeTab, setActiveTab] = useState('specs');

  // Product data - in a real app, this would come from an API
  const products = {
    1: {
      name: 'Galaxy S22 Ultra',
      price: 129999,
      old: 279999,
      desc: 'The Galaxy S22 Ultra redefines smartphone power with a 108MP camera, powerful processor, and S Pen support. Experience professional-grade photography and seamless multitasking.',
      img: 'https://images.unsplash.com/photo-1610945415295-d9bbf067e59c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      features: [
        '6.8-inch Dynamic AMOLED 2X Display',
        '108MP Professional Camera',
        'S Pen Integration',
        '5000mAh All-Day Battery',
        '45W Super Fast Charging',
      ],
      rating: 4.8,
      reviews: 1247,
    },
    2: {
      name: 'Galaxy M33 (4GB | 64GB)',
      price: 169999,
      old: 249999,
      desc: 'The Galaxy M33 offers a 6000mAh battery, smooth display, and Exynos 1280 processor. Perfect for users who need long-lasting performance.',
      img: 'https://images.unsplash.com/photo-1610945415295-d9bbf067e59c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      features: [
        '6.6-inch FHD+ Display',
        '6000mAh Massive Battery',
        'Exynos 1280 Processor',
        'Quad Camera System',
        '25W Fast Charging',
      ],
      rating: 4.3,
      reviews: 892,
    },
    3: {
      name: 'Galaxy Z Fold 4',
      price: 359999,
      old: 429999,
      desc: 'Experience the next generation of foldable smartphones with the Galaxy Z Fold 4. Unfold your world with a large, immersive display and premium performance.',
      img: 'https://images.unsplash.com/photo-1603898037225-3d3e3e3e7e6b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      features: [
        '7.6-inch Main Display',
        'Foldable Dynamic AMOLED 2X',
        'Multi-Active Window',
        'Under Display Camera',
        'IPX8 Water Resistance',
      ],
      rating: 4.7,
      reviews: 563,
    },
  };

  const product = products[id];
  const discountPercent = product
    ? Math.round(((product.old - product.price) / product.old) * 100)
    : 0;

  useEffect(() => {
    if (!product) {
      console.log('Product not found');
    }
  }, [product]);

  if (!product) {
    return (
      <div className='product-not-found'>
        <div className='not-found-container'>
          <h2>Product not found</h2>
          <p>The product you're looking for doesn't exist.</p>
          <Link to='/' className='back-home-btn'>
            Back to Home
          </Link>
        </div>
      </div>
    );
  }

  const handleAddToCart = () => {
    alert(`Added ${quantity} item(s) to cart!`);
    // In a real application, you would send this data to your server
  };

  const handleBuyNow = () => {
    alert(`Proceeding to checkout with ${quantity} item(s)!`);
    // In a real application, you would redirect to checkout page
  };

  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating - fullStars >= 0.5;
    const stars = [];

    for (let i = 0; i < fullStars; i++) {
      stars.push(<i key={`full-${i}`} className='fas fa-star'></i>);
    }

    if (hasHalfStar) {
      stars.push(<i key='half' className='fas fa-star-half-alt'></i>);
    }

    const emptyStars = 5 - stars.length;
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<i key={`empty-${i}`} className='far fa-star'></i>);
    }

    return stars;
  };

  const relatedProducts = Object.entries(products)
    .filter(([key]) => key !== id)
    .slice(0, 3); // Show max 3 related products

  return (
    <div className='view-page'>
      <div className='product-view'>
        <div className='product-image'>
          <div className='product-badge'>{discountPercent}% OFF</div>
          <img src={product.img} alt={product.name} />
        </div>

        <div className='product-details'>
          <div>
            <h1>{product.name}</h1>

            <div className='product-rating'>
              <div className='stars'>{renderStars(product.rating)}</div>
              <div className='reviews'>({product.reviews} reviews)</div>
            </div>

            <p className='product-description'>{product.desc}</p>

            <div className='price-container'>
              <p className='price'>
                LKR {product.price.toLocaleString()}
                <span>LKR {product.old.toLocaleString()}</span>
              </p>
              <p className='save'>
                You save LKR {(product.old - product.price).toLocaleString()}
                <span className='discount-percent'>{discountPercent}% OFF</span>
              </p>
            </div>

            <div className='product-features'>
              <h3>Key Features</h3>
              <ul className='features-list'>
                {product.features.map((feature, index) => (
                  <li key={index}>
                    <i className='fas fa-check'></i> {feature}
                  </li>
                ))}
              </ul>
            </div>

            <div className='quantity-selector'>
              <label htmlFor='quantity'>Quantity:</label>
              <input
                type='number'
                id='quantity'
                name='quantity'
                value={quantity}
                onChange={(e) => setQuantity(parseInt(e.target.value) || 1)}
                min='1'
                max='10'
              />
            </div>
          </div>

          <div>
            <div className='btn-group'>
              <button className='add-to-cart' onClick={handleAddToCart}>
                <i className='fas fa-shopping-cart'></i> Add to Cart
              </button>
              <button className='buy-now' onClick={handleBuyNow}>
                <i className='fas fa-bolt'></i> Buy Now
              </button>
              <Link to='/' className='back-btn'>
                <i className='fas fa-arrow-left'></i> Back to Home
              </Link>
            </div>

            <div className='additional-info'>
              <div className='info-tabs'>
                <div
                  className={`info-tab ${
                    activeTab === 'specs' ? 'active' : ''
                  }`}
                  onClick={() => setActiveTab('specs')}
                >
                  Specifications
                </div>
                <div
                  className={`info-tab ${
                    activeTab === 'shipping' ? 'active' : ''
                  }`}
                  onClick={() => setActiveTab('shipping')}
                >
                  Shipping Info
                </div>
                <div
                  className={`info-tab ${
                    activeTab === 'returns' ? 'active' : ''
                  }`}
                  onClick={() => setActiveTab('returns')}
                >
                  Returns
                </div>
              </div>

              <div
                className={`info-content ${
                  activeTab === 'specs' ? 'active' : ''
                }`}
              >
                <p>Display: 6.8-inch Dynamic AMOLED 2X, 120Hz</p>
                <p>Processor: Snapdragon 8 Gen 1</p>
                <p>Storage: 256GB / 512GB / 1TB</p>
                <p>RAM: 12GB</p>
                <p>Camera: 108MP + 12MP + 10MP + 10MP</p>
              </div>

              <div
                className={`info-content ${
                  activeTab === 'shipping' ? 'active' : ''
                }`}
              >
                <p>Free shipping on all orders over LKR 10,000</p>
                <p>Standard delivery: 3-5 business days</p>
                <p>Express delivery: 1-2 business days (additional charge)</p>
              </div>

              <div
                className={`info-content ${
                  activeTab === 'returns' ? 'active' : ''
                }`}
              >
                <p>30-day money-back guarantee</p>
                <p>Free returns within 14 days of delivery</p>
                <p>
                  Products must be in original condition with all accessories
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {relatedProducts.length > 0 && (
        <div className='related-products'>
          <h2>You Might Also Like</h2>
          <div className='related-grid'>
            {relatedProducts.map(([key, relatedProduct]) => {
              const relatedDiscount = Math.round(
                ((relatedProduct.old - relatedProduct.price) /
                  relatedProduct.old) *
                  100
              );
              return (
                <Link
                  key={key}
                  to={`/view/${key}`}
                  className='related-card'
                  onClick={() => window.scrollTo(0, 0)}
                >
                  <img src={relatedProduct.img} alt={relatedProduct.name} />
                  <div className='details'>
                    <h3>{relatedProduct.name}</h3>
                    <p className='price'>
                      LKR {relatedProduct.price.toLocaleString()}
                    </p>
                    <p className='save-text'>Save {relatedDiscount}%</p>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default View;
